import { Suspense } from 'react';
import { createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';
import withLazyLoading from '../../hoc/withLazyLoading';
import { SCADA_RULES, access } from '../../access';

const SetPointConfigurationPage = withLazyLoading(
  () => import('../../pages/setPointConfiguration'),
);

const setPointConfigurationRoute = [
  {
    path: '/set-point-configuration',
    handle: { ...createCrumbHandle('Set Point Configuration'), ...access(SCADA_RULES.author) },
    element: (
      <Suspense fallback={<Loader />}>
        <SetPointConfigurationPage />
      </Suspense>
    ),
  },
];

export default setPointConfigurationRoute;
